import { render, staticRenderFns } from "./WriteDynamicLog.vue?vue&type=template&id=bc504346&scoped=true"
import script from "./WriteDynamicLog.vue?vue&type=script&lang=js"
export * from "./WriteDynamicLog.vue?vue&type=script&lang=js"
import style0 from "./WriteDynamicLog.vue?vue&type=style&index=0&id=bc504346&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc504346",
  null
  
)

export default component.exports